/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

import useQueries from 'history/lib/useQueries';
import useBasename from 'history/lib/useBasename';

export default function useRouterHistory(createHistory) {
  return function (options) {
    var history = useQueries(useBasename(createHistory))(options);
    history.__v2_compatible__ = true;
    return history;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router/es6/useRouterHistory.js
// module id = 370
// module chunks = 60